import { render, staticRenderFns } from "./InputUppercaseRequired.vue?vue&type=template&id=6bae733e&scoped=true&"
import script from "./InputUppercaseRequired.vue?vue&type=script&lang=js&"
export * from "./InputUppercaseRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae733e",
  null
  
)

export default component.exports